
module.cC({
    name: 'ProgramInitiativeIndexController',
    inject: ['$scope', 'initiatives', 'moment'],
    data: {
        initiatives: 'initiatives',
    },
    methods: {},
});
